<template>
    <div>
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import Axios from 'axios'

export default {
    created() {
        if ( this.$route.params.hasOwnProperty('token') && this.$route.params.token ) {
            // AUTHENTICATE TOKEN... 
            let vQuery = this.$route.query;
            let redirect = this.$route.query.redirect || null;
            let auth = {
                "access_token": this.$route.params.token || null,
                "token_type": this.$route.query.token_type || null,
                "expires_in": this.$route.query.expires_in || null,
                "refresh_token": this.$route.query.refresh_token || null
            }

            if ( auth.token_type && auth.access_token ) {
                this.$store.commit('base/setLoadingPage', true)
                
                localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
                localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(auth))
                
                Axios.defaults.headers.common['Authorization'] = null
                Axios.defaults.headers.common['Authorization'] = this.$route.params.token_type + " " + this.$route.params.token;
            
                setTimeout( () => {
                    this.$store.commit('base/setLoadingPage', false)        
                    this.$router.replace(redirect || "/home");
                }, 3000);
            }
        } else {
            this.$router.replace("/home");
        }
    }
}
</script>

